module.exports = __webpack_public_path__ + "static/media/phone-icon.e1620080.svg";